import { FileContainer, FileStatuses, FileWithPreview, PreparedDescription } from 'Modules'
import { formatDateForNewUpload, getActualSize } from 'Helpers'

export const getResultFile = (
	acceptedFiles: FileWithPreview[],
	maxFilesCount: number,
	filesFormState?: FileWithPreview[]
) => {
	const files = filesFormState || []
	return maxFilesCount === 1
		? acceptedFiles[0]
		: files.concat(acceptedFiles).slice(0, maxFilesCount)
}

export const prepareFileDescr = (descriptionsArray: string[]): PreparedDescription => {
	return descriptionsArray.join(' • ')
}

export const getFilesFromContainer = (list: FileContainer[]) => list.map((file) => file.file)

export const formatForFileContainer = (rawFileArray: FileWithPreview[]): FileContainer[] =>
	rawFileArray.map(
		(elem) =>
			({
				file: elem,
				status: FileStatuses.COMPLETE,
				description: prepareFileDescr([
					getActualSize(elem?.size),
					formatDateForNewUpload(elem?.created_at ?? new Date().toString()),
				]),
			} as FileContainer)
	)
